import { forumBoards } from "@/mocks/gossip";

const roleMap: Record<string, { icon: string; chip: string }> = {
  primary: { icon: "bg-primary-100 text-primary-700", chip: "bg-primary-100 text-primary-800" },
  accent: { icon: "bg-accent-100 text-accent-800", chip: "bg-accent-100 text-accent-900" },
  secondary: { icon: "bg-secondary-100 text-secondary-800", chip: "bg-secondary-100 text-secondary-900" },
};

export default function ForumBoards() {
  return (
    <section id="forum" className="w-full scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-accent-700">
              <i className="ri-layout-grid-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              吃瓜论坛
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">论坛版块 · 找到你的吃瓜聚集地</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              论坛按兴趣划分为多个版块，每个版块都有自己的讨论节奏与运营规则。先选一个你最感兴趣的方向，慢慢熟悉之后再参与发帖。
            </p>
          </div>
          <a
            href="#guide"
            className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-background-300 bg-background-100 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap self-start"
          >
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            先看新手指南
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {forumBoards.map((board) => {
            const role = roleMap[board.role] ?? roleMap.primary;
            return (
              <a
                key={board.name}
                href="#latest"
                className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50 cursor-pointer"
              >
                <span className={`flex items-center justify-center w-11 h-11 rounded-md ${role.icon}`}>
                  <i className={`${board.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 text-base font-medium text-foreground-950">{board.name}</h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{board.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span>{board.threads} 主题</span>
                  <span className={`rounded px-2 py-0.5 ${role.chip}`}>今日 +{board.today}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}